import * as React from 'react';
import { Row, Col, Button } from 'reactstrap';
import { BeatLoader } from 'react-spinners';
import { Location } from 'history';
import { IAuthState, UserTypes } from '../store/types';
import routes from '../../Routing/routes';
import { cognitoOAuth } from '../../../share/services/cognito-oauth';

export interface ILoginState {
  errorMessage: string;
  loading: boolean;
}

export interface ILoginProps {
  auth: IAuthState;
  history: any;
  location: Location<any>;
}

// Login is now a single action: hand off to the Cognito hosted UI (managed login),
// which owns credentials, MFA, and password reset. The in-app SRP/MFA forms were
// removed in the OAuth-only cutover.
export class Login extends React.Component<ILoginProps, ILoginState> {
  constructor(props: ILoginProps) {
    super(props);
    this.state = { errorMessage: '', loading: false };
  }

  public componentDidMount(): void {
    this.checkAuth(this.props.auth.userType);
  }
  public componentWillReceiveProps(nextProps: ILoginProps): void {
    // Redirect once redux reports an authenticated user (set by completeLogin).
    this.checkAuth(nextProps.auth.userType);
  }
  public checkAuth(userType): void {
    if (userType !== UserTypes.UNAUTH) {
      const state = this.props.location.state;
      const to = (state && state.from) || routes.HOME;
      this.props.history.replace(to);
    }
  }

  public loginWithCognito = async (): Promise<void> => {
    this.setState({ loading: true, errorMessage: '' });
    try {
      // Preserve the intended destination across the hosted-UI round-trip (router/
      // redux state is lost when we leave the SPA). AuthRoute sets location.state.from.
      const state = this.props.location.state as any;
      const from = state && state.from;
      const dest = typeof from === 'string' ? from : (from && `${from.pathname || ''}${from.search || ''}`);
      cognitoOAuth.setPostLoginRedirect(dest);
      const url = await cognitoOAuth.buildAuthUrl();
      window.location.assign(url);
    } catch (error) {
      this.setState({ loading: false, errorMessage: 'Could not start sign-in. Please try again.' });
    }
  }

  public render(): React.ReactElement {
    const { loading, errorMessage } = this.state;
    return (
      <>
        <Row>
          <Col md={12}>
            <Button block={true} disabled={loading} onClick={this.loginWithCognito}>
              Sign in
            </Button>
          </Col>
        </Row>
        {loading ? <BeatLoader loading={loading} /> : <div className="FormError">{errorMessage}</div>}
      </>
    );
  }
}

export default Login;
